import { Box } from "@mui/material";

/**
 * * Adds a video background to a container, and then renders the children of the container on top of the video
 * @param {Object} props
 * @param {string} props.src
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement} VideoBackgroundContainer
 */
export default function VideoBackgroundContainer({ src, children }) {
  return (
    <Box
      data-testid="video-background-container"
      height="100%"
      sx={{ position: "relative", overflow: "hidden" }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="background-video"
        aria-label="background-video"
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {children}
    </Box>
  );
}
